// extracted by mini-css-extract-plugin
export default {"tableHead":"UsersList_tableHead__O4vin","tableBodyRow":"UsersList_tableBodyRow__2c+-l"};